import styled from 'styled-components'

import { AmountFormatted } from '@root/shared/core/format'

import type { BigNumber } from 'bignumber.js'

type Props = {
  ticker: string
  balance: BigNumber
  balanceUsd: BigNumber
}

export const WalletAssetsBalanceCell: React.FC<Props> = ({
  ticker,
  balance,
  balanceUsd,
}) => {
  const renderTicker = ticker.length > 6 ? ticker.slice(0, 4) + '…' : ticker

  return (
    <BalanceContainer>
      <BalanceNative>
        <AmountFormatted
          amount={balance}
          currency={renderTicker}
          roundingMode="trunc"
        />
      </BalanceNative>
      <Separator />
      <BalanceUsd>
        <AmountFormatted
          amount={balanceUsd}
          currency="$"
          roundingMode="trunc"
        />
      </BalanceUsd>
    </BalanceContainer>
  )
}

const BalanceContainer = styled.div`
  display: grid;
  grid-template-columns: 100px 1px auto;
  align-items: center;
  column-gap: 8px;
  height: 18px;
`

const BalanceNative = styled.div`
  justify-self: start;
  min-width: 0;
  color: var(--text-12);
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
`
const BalanceUsd = styled.div`
  justify-self: start;
  min-width: 0;
  color: var(--text-9);
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
`

const Separator = styled.div`
  width: 1px;
  height: 18px;
  background-color: var(--background-2);
`
